import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {LocationPoint} from '@/common/interfaces/location';

export const fetchRecentLocationsAction = createAsyncThunk<
	{language: string; limit: number},
	{recentLocations: LocationPoint[]; limit: number},
	void
>('locationsHistory/fetchRecentLocations', async ({language, limit}, {context, success}) => {
	const recentLocations = await context.backendAPI.location.getRecentLocations(language, limit);
	return success({recentLocations, limit});
});
